import { EmojiIconId, Emojis } from './emojis'

export const getEmojiSvg = ({
  iconId,
  size,
  darkMode,
}: {
  iconId: Lowercase<EmojiIconId> | (string & {}) // Allows any string to be passed in but provides type hints
  size: 24 | 48
  darkMode: boolean
}) => {
  const emoji = Emojis[iconId.toUpperCase() as EmojiIconId]

  if (!emoji) {
    throw Error(`No emoji found for icon ID "${iconId}"`)
  }

  const themedEmoji = emoji[darkMode ? 'dark' : 'light']

  return size === 24 ? themedEmoji.svg24 : themedEmoji.svg48
}
